/** Toggle-button label for the methodology narrative tab (short label avoids truncation). */
export const NARRATIVE_METHODOLOGY_TAB_LABEL = 'Methods';

/** Tab label for custom/admin titles; maps legacy "Methodology" to the short tab label. */
export function narrativeMethodologyTabLabel(customTitle?: string | null): string {
  const t = customTitle?.trim();
  if (!t || t === 'Methodology') return NARRATIVE_METHODOLOGY_TAB_LABEL;
  return t;
}
